import { forwardRef, type Ref, type SVGProps } from "react";

function SvgSilverDiamondCloud(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={101}
      height={101}
      fill="none"
      {...props}
    >
      <path
        fill="url(#SilverDiamondCloud_svg__a)"
        stroke="#8DA5B8"
        strokeWidth={4}
        d="M38.71 6.884c6.512-6.511 17.068-6.511 23.58 0l1.1 1.1a12.67 12.67 0 0 0 8.96 3.711h.282c9.208 0 16.672 7.465 16.673 16.673v.281a12.67 12.67 0 0 0 3.712 8.961l1.1 1.1c6.51 6.512 6.51 17.068 0 23.58l-1.1 1.1a12.67 12.67 0 0 0-3.712 8.96v.282c0 9.208-7.465 16.672-16.673 16.673h-.281a12.67 12.67 0 0 0-8.961 3.712l-1.1 1.1c-6.512 6.51-17.068 6.51-23.58 0l-1.1-1.1a12.67 12.67 0 0 0-8.96-3.712h-.282c-9.208 0-16.672-7.465-16.673-16.673v-.281a12.67 12.67 0 0 0-3.712-8.961l-1.1-1.1c-6.51-6.512-6.51-17.068 0-23.58l1.1-1.1a12.67 12.67 0 0 0 3.712-8.96v-.282c0-9.208 7.465-16.672 16.673-16.673h.281a12.67 12.67 0 0 0 8.961-3.712l1.1-1.1Z"
      />
      <path
        fill="url(#SilverDiamondCloud_svg__b)"
        d="M29.248 40.13 49.84 28.31A2.33 2.33 0 0 1 51 28c.406 0 .805.107 1.161.311l20.59 11.819c.296.17.554.401.757.68a2.62 2.62 0 0 1 .451 1.987 2.6 2.6 0 0 1-.385.962L52.982 74.914a2.44 2.44 0 0 1-.863.798 2.33 2.33 0 0 1-2.238 0 2.45 2.45 0 0 1-.863-.798L28.426 43.76a2.6 2.6 0 0 1-.385-.962 2.62 2.62 0 0 1 .45-1.986c.204-.28.462-.512.757-.681z"
      />
      <defs>
        <linearGradient
          id="SilverDiamondCloud_svg__a"
          x1={29.575}
          x2={50.5}
          y1={4}
          y2={97}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F8FBFD" />
          <stop offset={1} stopColor="#E8F0F5" />
        </linearGradient>
        <linearGradient
          id="SilverDiamondCloud_svg__b"
          x1={35.667}
          x2={52.176}
          y1={34}
          y2={75.532}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5A6B7A" />
          <stop offset={1} stopColor="#C8D5E0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgSilverDiamondCloud);
export default ForwardRef;
